<template>
  <div class="card-content">
    <div class="level">
      <div class="level-left">
        <router-link-blank :to="{ name: 'l.gabed.materielTlpe',
                            params: { id: commandeTlpe.intervenants[0].tiersId }}"
                            typeIcon="is-primary"
                            :message="$t('detailCommandeTlpe.infoMateriel.lienVersMaterielTexte')">
        </router-link-blank>
      </div>
      <div class="level-right">
        <exportExcelButton
          :perm="constantes.COMMANDE_TLPE.exporter"
          :query="exportExcelQuery"/>
      </div>
    </div>
    <v-client-table
        :data="commandeTlpe.lignesCommande"
        :columns="columns"
        :options="options">
        <template slot="appendBody">
          <table-footer-totaux
            :columns="columns"
            :items="commandeTlpe.lignesCommande"
            :target="['totalHt']">
          </table-footer-totaux>
        </template>
        <template slot="code" slot-scope="{ row }" >
          {{ row.code }}
        </template>
        <template slot="libelle" slot-scope="{ row }" >
          {{ row.libelle }}
        </template>
        <template slot="descriptionTlpe" slot-scope="{ row }" >
          {{ getLabelDescription(row.designationTlpe) }}
        </template>
        <template slot="date" slot-scope="{ row }" >
          {{ row.date | formatDate }}
        </template>
        <template slot="dateDebut" slot-scope="{ row }" >
          {{ row.date | formatDate }}
        </template>
        <template slot="dateFin" slot-scope="{ row }" >
          {{ row.dateFin | formatDate }}
        </template>
        <template slot="numerique" slot-scope="{ row }" >
          {{ row.numerique? $t('general.oui') : $t('general.non') }}
        </template>
        <template slot="nbFacesDeclarees" slot-scope="{ row }" >
          <div class="is-pulled-right">
            {{ row.nbFacesDeclarees }}
          </div>
        </template>
        <template slot="surfaceUnitaire" slot-scope="{ row }" >
          <div class="is-pulled-right">
            {{ row.surfaceUnitaire }}
          </div>
        </template>
        <template slot="quantite" slot-scope="{ row }" >
          <div class="is-pulled-right">
            {{ row.lignesCommande[0].quantite }}
          </div>
        </template>
        <template slot="prixUnitaire" slot-scope="{ row }" >
          <div class="is-pulled-right">
            {{ row.lignesCommande[0].prixUnitaire  | formatDevise }}
          </div>
        </template>
        <template slot="totalHt" slot-scope="{ row }" >
          <div class="is-pulled-right">
            {{ row.totalHt | formatDevise }}
          </div>
        </template>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  DEMONTAGES_ANNEE_PREC, MATERIEL_EN_PLACE, LISTE_TYPE_DECLARATION_AU_FIL_DE_LEAU,
  EXPORT_EXCEL_LIGNE_COMMANDE_TLPE, LISTE_DESCRIPTION_TLPE,
} from '@/configuration/gabed/tlpe/tlpeConf';
import { COMMANDE_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  NO_PER_PAGE_VALUE,
  NO_PAGINATION,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import exportExcelButton from '@/components/general/button/exportExcelButton';

export default {
  props: {
    commandeTlpe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        MATERIEL_EN_PLACE,
        COMMANDE_TLPE,
      },
    };
  },
  components: {
    routerLinkBlank,
    tableFooterTotaux,
    exportExcelButton,
  },
  computed: {
    getLabelDate() {
      if (this.commandeTlpe.typeDeclaration === DEMONTAGES_ANNEE_PREC) {
        return this.$i18n.t('detailCommandeTlpe.infoMateriel.tab.dateSuppression');
      }
      return this.$i18n.t('detailCommandeTlpe.infoMateriel.tab.dateCreation');
    },
    isDeclarationAuFilDeLeau() {
      return !!LISTE_TYPE_DECLARATION_AU_FIL_DE_LEAU
        .map(i => i.code)
        .includes(this.commandeTlpe.typeDeclaration);
    },
    columns() {
      const col = ['code', 'libelle', 'descriptionTlpe', 'dateDebut', 'dateFin', 'numerique', 'nbFacesDeclarees', 'surfaceUnitaire', 'quantite', 'prixUnitaire', 'totalHt'];

      return col;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('detailCommandeTlpe.infoMateriel.tab.codeMateriel'),
          libelle: this.$t('detailCommandeTlpe.infoMateriel.tab.adresse'),
          descriptionTlpe: this.$t('detailCommandeTlpe.infoMateriel.tab.descriptionTlpe'),
          dateDebut: this.$t('detailCommandeTlpe.infoMateriel.tab.dateDebut'),
          dateFin: this.$t('detailCommandeTlpe.infoMateriel.tab.dateFin'),
          numerique: this.$t('detailCommandeTlpe.infoMateriel.tab.numerique'),
          nbFacesDeclarees: this.$t('detailCommandeTlpe.infoMateriel.tab.nbFace'),
          surfaceUnitaire: this.$t('detailCommandeTlpe.infoMateriel.tab.superficie'),
          quantite: this.$t('detailCommandeTlpe.infoMateriel.tab.quantite'),
          prixUnitaire: this.$t('detailCommandeTlpe.infoMateriel.tab.prixUnitaire'),
          totalHt: this.$t('detailCommandeTlpe.infoMateriel.tab.totalHt'),
        },
        pagination: {
          show: false,
        },
        sortable: ['code', 'libelle', 'descriptionTlpe', 'dateDebut', 'dateFin', 'numerique', 'nbFacesDeclarees', 'surfaceUnitaire', 'quantite', 'prixUnitaire', 'totalHt'],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        customSorting: {
          dateDebut: (asc) => {
            return (a, b) => {
              if (asc) return a.date > b.date ? 1 : -1;
              return a.date < b.date ? 1 : -1;
            };
          },
        },
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_LIGNE_COMMANDE_TLPE,
        typeExport: null,
        parametresAdditionnels: {
          Id: this.commandeTlpe.id,
        },
      };
    },
  },
  methods: {
    getLabelDescription(description) {
      const descriptionFind = (LISTE_DESCRIPTION_TLPE.find((d) => {
        return d.code === description;
      }));
      return descriptionFind ? this.$i18n.t(descriptionFind.libelle) : description;
    },
  },
};

</script>
